import { GetterTree } from 'vuex';
import { TelemetryState, TelemetryGetter } from './types';
import { RootState } from '@/store/types';
import { Models } from '@mtap-smartcity/api';

function telemetryKey(objectId: string, deviceType: Models.Constants.DeviceType): string {
  return `${objectId}::${deviceType}`;
}

export const getters: GetterTree<TelemetryState, RootState> = {
  [TelemetryGetter.GetLastTelemetry](state): (
    objectId: string,
    deviceType: Models.Constants.DeviceType
  ) => Models.Telemetries.Telemetry | null {
    const lastTelemetryByKey = new Map<string, Models.Telemetries.Telemetry>();
    state.lastTelemetries.forEach((reading: Models.Telemetries.Telemetry) => {
      lastTelemetryByKey.set(telemetryKey(reading.object_id, reading.device_type), reading);
    });
    return (objectId: string, deviceType: Models.Constants.DeviceType) => (
      lastTelemetryByKey.get(telemetryKey(objectId, deviceType)) ?? null
    );
  },
};
